// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--expansion-duration:0.575s}.expansion,.expansion>div{will-change:height;transform:translateZ(0);backface-visibility:hidden;perspective:1000px}.expansion-enter-active,.expansion-leave-active{transition:height var(--expansion-duration) ease-in-out;overflow:hidden}.expansion-enter,.expansion-leave-to{height:0}", ""]);
// Exports
module.exports = exports;
